import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Input, Typography} from "@material-tailwind/react";
import React from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {bankPayment} from "../../services/payment/payment";
import {parseInt} from "lodash";
import SelectInput from "../system/select";
import {
  DEFAULT_PAYMENT_METHOD,
  PAYMENT_GATEWAY_OPTIONS,
  redirectToPaymentLink
} from "../../helper/paymentGateway";

export function ChargeWalletForm({
                                   modalOpen,
                                   setModalOpen,
                                   setStep,
                                   setLastDataRefresh,
                                   chargeAmount,
                                   setChargeAmount,
                                   chargeDiscountCode,
                                   agentId,
                                   branchId,
                                   userStartTime,
                                   minute,
                                   jalaliDate
                                 }) {
  const [paymentMethod, setPaymentMethod] = React.useState(DEFAULT_PAYMENT_METHOD);


  const handleOpen = () => setModalOpen(!modalOpen);

  const bank_payment = async () => {
    const data = {
      amount: parseInt(chargeAmount),
      description: "reservation",
      payment_method: paymentMethod
    };

    let result;
    result = await bankPayment(data)
    if (result.status === 200) {
      const {id} = result.data;
      localStorage.setItem("transaction_id", id)
      localStorage.setItem("reservation", JSON.stringify({
        "agentId": agentId,
        "branchId": branchId,
        "userStartTime": userStartTime,
        "minute": minute,
        "scheduleId": id,
        "jalaliDate": jalaliDate,
      }))
      localStorage.setItem("discountCode", chargeDiscountCode)
      redirectToPaymentLink(result.data);
    }
  };

  return (
    <>
      <Dialog size="l" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen mt-20">
        <DialogHeader className="bg-gray-800 rounded-2xl -mt-4">
          <Typography className="py-2 w-full text-white text-2xl z-10 textCenter">
            شارژ کیف پول
          </Typography>
        </DialogHeader>

        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="grid grid-cols-1 gap-4 mb-4 w-full md:grid-cols-[1fr_1fr_auto]">
            <Input variant="standard"
                   size="lg"
                   value={chargeAmount}
                   label={Dict('charge_amount')}
                   placeholder={Dict('charge_amount')}
                   onChange={(e) => {
                     setChargeAmount(e.target.value);
                   }}
            />
            <div className="flex flex-col">
              <SelectInput
                label="درگاه پرداخت"
                defaultValue={paymentMethod}
                refreshSignal={paymentMethod}
                options={PAYMENT_GATEWAY_OPTIONS}
                onChange={setPaymentMethod}
              />
            </div>
            <Button variant="gradient" size="l" color="gray" onClick={bank_payment}
                    className="rounded text-center">
              ورود به درگاه بانکی
            </Button>
          </div>
          {chargeAmount && persianNumberFormat(chargeAmount).length > 0 &&
            <div className="flex flex-row mb-4 w-full mx-2">
              <Typography variant="standard"
                          className="flex flex-col w-1/2"
                          color="blue-gray"
              >
                {persianNumberFormat(chargeAmount, true) + " ریال"}
              </Typography>
            </div>
          }

        </DialogBody>

        <DialogFooter className="justify-end -mt-4">
          <div className=" flex flex-row left-0">
            <Button variant="text" color="gray" onClick={() => {
              setStep(2)
            }}>
              <span>بازگشت</span>
            </Button>
          </div>
        </DialogFooter>
      </Dialog>
    </>
  );
}
